var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.columnSupports)?_c('mdi',{staticClass:"VisualisationToggle",attrs:{"icon":_vm.active ? 'eye' : 'eye-off'},on:{"click":_vm.toggle}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }